import React from 'react';
import NavigationMenuItem from "./menu-item";
import NavigationSection from "../../../core/model2/navigation/navigation-section";

type Props = {
    className?              : string,
    name                    : string,
    icon                    : string,
    url                     : string,
    navigationSection       : NavigationSection
    saveUrl?                : boolean
}

export default function NavigationMenuItemSectionLink(props:Props) {

    return <NavigationMenuItem name={props.name}
                               className={props.className}
                               selected={false}
                               icon={props.icon}
                               url={props.url}
                               navigationSection={props.navigationSection}
                               upgradeRequired={false}
                               saveUrl={false}
                               showLongArrow={true}

    />

}

